import { server } from './config'
import client from './client'

export default {
  getCountries(data = {}, config = {}) {
    return client.get(`${server}/checkin/api/countries?language=${data}`)
  }
}
